import { render, staticRenderFns } from "./planogram.vue?vue&type=template&id=f21a52e8&scoped=true&"
import script from "./planogram.vue?vue&type=script&lang=js&"
export * from "./planogram.vue?vue&type=script&lang=js&"
import style0 from "./planogram.vue?vue&type=style&index=0&id=f21a52e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21a52e8",
  null
  
)

export default component.exports